import {Component, Input, OnInit, ViewChild} from '@angular/core';
import { Form, UntypedFormArray, UntypedFormControl, UntypedFormGroup, ReactiveFormsModule, FormsModule } from '@angular/forms';
import {
    EditPermissions,
    NodeBuilder,
} from '../../../../../../../shared/models';
import {tap} from 'rxjs/operators';
import {FlowManagerService} from '../../../../../services/flow-manager.service';
import find from 'lodash/find';
import filter from 'lodash/filter';
import map from 'lodash/map';
import {newStepValue} from '../../../../../services/flowBuilder/utils/constants';
import {required, variableOrValueLength} from '../../../../../../../shared/utils';
import { MatAutocompleteTrigger, MatAutocompleteOrigin, MatAutocomplete } from '@angular/material/autocomplete';
import {Observable} from 'rxjs';
import { ClickatellExpansionPanelComponent } from '../../../../../../../shared/components/clickatell-expansion-panel/clickatell-expansion-panel.component';
import { MatExpansionPanelTitle } from '@angular/material/expansion';
import { ActiveFormDirective } from '../../../../../../../shared/directives/active-form/active-form.directive';
import { InputValidatorsComponent } from '../../templates/input-validators/input-validators.component';
import { MatSelect, MatOption } from '@angular/material/select';
import { MatButtonToggleGroup, MatButtonToggle } from '@angular/material/button-toggle';
import { NgClass, NgTemplateOutlet } from '@angular/common';
import { CMSComponent } from '../../../../../../../shared/components/cms/cms.component';
import { MatSlideToggle } from '@angular/material/slide-toggle';
import { LoadingIconComponent } from '../../../../../../../shared/components/loading-icon/loading-icon.component';
import { NextSelectorComponent } from '../../../../json-to-from/next-selector/next-selector.component';

const NODE_TYPE = 'chat2pay';
@Component({
    selector: 'app-chat2pay',
    templateUrl: './chat2pay.component.html',
    styleUrls: ['./chat2pay.component.scss'],
    imports: [ClickatellExpansionPanelComponent, MatExpansionPanelTitle, ReactiveFormsModule, ActiveFormDirective, InputValidatorsComponent, MatSelect, MatOption, MatButtonToggleGroup, MatButtonToggle, NgClass, MatAutocompleteOrigin, FormsModule, MatAutocompleteTrigger, MatAutocomplete, CMSComponent, MatSlideToggle, NgTemplateOutlet, LoadingIconComponent, NextSelectorComponent]
})
export class Chat2payComponent extends NodeBuilder implements OnInit  {
    PAYMENT_COMPLETED: UntypedFormGroup;
    PAYMENT_DECLINED: UntypedFormGroup;
    PAYMENT_UNKNOWN: UntypedFormGroup;
    PAYMENT_REVIEW: UntypedFormGroup;
    TIMEOUT: UntypedFormGroup;
    ERROR: UntypedFormGroup;

    additionalData: UntypedFormArray;

    payment: UntypedFormGroup = undefined;
    menuParams: UntypedFormGroup = undefined;
    results: UntypedFormGroup = undefined;

    canEdit: EditPermissions;

    extensions: any[] = [];

    chat2PayResult = false;
    loadingInProgress = true;
    variableValue = '';
    chat2payAPIData: any = null;
    chat2payAllAPIData: any;
    selectedMoneyType: any;
    filteredOptions: any;
    selected: any;
    stepUniqueID = '';

    activeSearchMoneyTypes = false;
    searchControl: UntypedFormControl = new UntypedFormControl();
    @ViewChild('searchMoneyType', {
        read: MatAutocompleteTrigger
    })
    autoComplete: MatAutocompleteTrigger;

    constructor(private flowManagerService: FlowManagerService) {
        super(NODE_TYPE);
    }

    ngOnInit() {}

    get getStepData(): {} {
        const paymentRawData  = this.payment.getRawValue();
        const menuParams  = this.menuParams.getRawValue();
        const results = this.results.getRawValue();

        const name = paymentRawData.name;
        const payment = this.getPaymentData(paymentRawData);

        for (const result in results) {
            delete results[result].key;
        }

        if (menuParams.generateOrderNumber === true) {
            menuParams.orderNumber = '';
        }

        const additionalData = {};
        map(menuParams.additionalData, (item) => {
            additionalData[item.key] = item.value;
        });
        return {
            menu: {
                name,
                menuType: 'chat2pay',
                payment: {
                    ...payment
                },
                menuParams: {
                    ...menuParams,
                    additionalData
                },
                results
            },
            type: 'menu',
            metadata: {
                nodeVersion: '1.0.0',
                stepUniqueID: this.stepUniqueID
            }
        };
    }

    get isNodeValid(): boolean {
        this.payment.markAllAsTouched();
        this.menuParams.markAllAsTouched();
        return this.payment.valid && this.menuParams.valid;
    }

    set buildForm(stepData: any) {
        this.initForm();

        if (stepData) {
            this.stepUniqueID = stepData.metadata?.stepUniqueID ? stepData.metadata?.stepUniqueID : '';
            this.setDataToForm(stepData);
        }

        this.getC2P(stepData);
    }

    initForm() {
        this.payment = this.getPaymentTemplate();
        this.menuParams = this.getMenuParamsTemplate();
        this.results = this.getResultsTemplate();
    }

    getPaymentTemplate() {
        this.additionalData = new UntypedFormArray([]);
        return new UntypedFormGroup({
            name:  new UntypedFormControl('', [required('Name')]),
            extension: new UntypedFormControl('', [required('Extension')]),
            messageForLink: new UntypedFormControl('', [required('Message for Link')]),
            currencyCode: new UntypedFormControl('USD', [required('Currency Variable')]),
            currency: new UntypedFormControl('predefined', [required('Currency')]), // +
            amount: new UntypedFormControl('', [required('Amount')]),
            tax: new UntypedFormControl(''),
            itemDescription: new UntypedFormControl(''),
            autoReversePayment: new UntypedFormControl(false),
            confirmationMessage: new UntypedFormControl('', [required('Confirmation Message')])
        });
    }

    private getPaymentData(payment) {
        return {
            extension: payment.extension,
            messageForLink: payment.messageForLink,
            currencyCode: payment.currencyCode,
            currency: payment.currency,
            amount: payment.amount,
            tax: payment.tax,
            itemDescription: payment.itemDescription,
            autoReversePayment: payment.autoReversePayment,
            confirmationMessage: payment.confirmationMessage,
        };

    }

    getMenuParamsTemplate() {
        return new UntypedFormGroup({
            apiToken: new UntypedFormControl('', [required('API Token')]),
            generateOrderNumber: new UntypedFormControl(true),
            orderNumber: new UntypedFormControl(''),
            additionalData: this.additionalData
        });
    }

    getResultsTemplate() {
        this.PAYMENT_COMPLETED = new UntypedFormGroup({
            key: new UntypedFormControl('PAYMENT_COMPLETED', [required('Payment Succeeds')]),
            next: new UntypedFormControl(newStepValue),
            description: new UntypedFormControl('Payment Succeeds')
        });
        this.PAYMENT_DECLINED = new UntypedFormGroup({
            key: new UntypedFormControl('PAYMENT_DECLINED', [required('Payment Failed')]),
            next: new UntypedFormControl(newStepValue),
            description: new UntypedFormControl('Payment Failed')
        });
        this.PAYMENT_UNKNOWN = new UntypedFormGroup({
            key: new UntypedFormControl('PAYMENT_UNKNOWN', [required('Payment Unknown')]),
            next: new UntypedFormControl(newStepValue),
            description: new UntypedFormControl('Payment Unknown')
        });
        this.PAYMENT_REVIEW = new UntypedFormGroup({
            key: new UntypedFormControl('PAYMENT_REVIEW', [required('Payment requires a review')]),
            next: new UntypedFormControl(newStepValue),
            description: new UntypedFormControl('Payment requires a review')
        });
        this.TIMEOUT = new UntypedFormGroup({
            key: new UntypedFormControl('TIMEOUT', [required('Timeout')]),
            next: new UntypedFormControl(newStepValue),
            description: new UntypedFormControl('Timeout')
        });
        this.ERROR = new UntypedFormGroup({
            key: new UntypedFormControl('ERROR', [required('Communications error with Chat2Pay')]),
            next: new UntypedFormControl(newStepValue),
            description: new UntypedFormControl('Communications error with Chat2Pay')
        });
        return new UntypedFormGroup({
            PAYMENT_COMPLETED: this.PAYMENT_COMPLETED,
            PAYMENT_DECLINED: this.PAYMENT_DECLINED,
            PAYMENT_UNKNOWN: this.PAYMENT_UNKNOWN,
            PAYMENT_REVIEW: this.PAYMENT_REVIEW,
            TIMEOUT: this.TIMEOUT,
            ERROR: this.ERROR
        });
    }

    setDataToForm(stepData: any) {
        if (stepData.menu) {
            let { menuParams } = stepData.menu;
            const { results, payment } = stepData.menu;

            payment['name'] = stepData.menu.name;

            const additionalData = [];
            for (const key in menuParams.additionalData) {
                additionalData.push({
                    key,
                    value: menuParams.additionalData[key]
                });
            }

            map(additionalData, () => {
                this.addAdditionalData();
            });

            menuParams = {
                ...menuParams,
                additionalData
            };

            this.menuParams.patchValue(menuParams);
            this.results.patchValue(results);
            this.payment.patchValue(payment);

            map(this.additionalData.controls, (control, index) => {
                control.patchValue(additionalData[index]);
            });

            if (menuParams.generateOrderNumber === false) {
                this.updateOrderNumberRequiredValidator(true);
            }
        }
    }

    addAdditionalData() {
        this.additionalData.push(this.additionalDataItemTemplate());
    }

    additionalDataItemTemplate() {
        return new UntypedFormGroup({
            key: new UntypedFormControl('', [required('Additional Data Key')]),
            value: new UntypedFormControl('', [required('Additional Data Value')])
        });
    }

    getC2P(stepData: any) {
        this.chat2PayResult = false;
        if (this.chat2payAPIData === null) {
            this.loadingInProgress = true;
            this.flowManagerService.getChat2PayExtensions().pipe(
                tap((resp: any) => {
                    const { body, status } = resp;
                    if (status === 200) {
                        this.chat2payAllAPIData = body;
                        const payment = (stepData.menu && stepData.menu.payment && stepData.menu.payment)
                            ? stepData.menu.payment
                            : null;
                        const paymentExtension = (payment && payment.extension) ? payment.extension : '';
                        const key = paymentExtension && body.hasOwnProperty(paymentExtension)
                            ? paymentExtension
                            : Object.keys(body)[0];

                        if (payment && payment.currencyCode) {
                            this.setActiveMoneyTypeFromData(body[key], payment.currencyCode);
                        } else {
                            this.setChat2payData(body[key]);
                        }
                        this.setExtensions(body, key);
                        this.chat2payAPIData = body[key];
                        this.chat2PayResult = true;
                    } else {
                        this.chat2payAPIData = null;
                        this.chat2payAllAPIData = null;
                    }
                }))
                .subscribe(
                    () => {
                        this.loadingInProgress = false;
                    },
                    () => {
                        this.loadingInProgress = false;
                        this.chat2payAPIData = null;
                        this.chat2payAllAPIData = null;
                    }
                );
        }
    }

    setChat2payData(responseBody) {
        this.selectedMoneyType = find(responseBody.supportedCurrencies, (o) => {
            return o.isDefault;
        });

        if (!this.selectedMoneyType) {
            this.selectedMoneyType = responseBody.supportedCurrencies[0];
        }

        this.menuParams.get('apiToken').setValue(responseBody.apiKey);
        this.payment.get('currencyCode').setValue(this.selectedMoneyType ? this.selectedMoneyType.iso : '');
        this.filteredOptions = responseBody.supportedCurrencies;
    }

    setActiveMoneyTypeFromData(data, value) {
        if (data && value) {
            const { supportedCurrencies } = data;
            this.selectedMoneyType = find(supportedCurrencies, o => {
                return o.iso === value;
            });
        }
    }

    setExtensions(data, extensionKey) {
        for (const key in data) {
            const { id, name } = data[key];
            this.extensions.push({ id, name });
        }
        this.payment.get('extension').setValue(extensionKey);
        this.selected = extensionKey;
    }

    currencyChanged(event) {
        if (event.value === 'predefined') {
            const currencyCode = this.payment.get('currencyCode');
            if (currencyCode && currencyCode.value && !this.selectedMoneyType) {
                const { supportedCurrencies } = this.chat2payAPIData;
                if (supportedCurrencies) {
                    this.selectedMoneyType = find(supportedCurrencies, o => {
                        return o.name === currencyCode.value;
                    });
                }
            }
        }
    }

    setActiveMoneyType(value) {
        if (this.chat2payAPIData) {
            const { supportedCurrencies } = this.chat2payAPIData;
            this.selectedMoneyType = find(supportedCurrencies, o => {
                return o.name === value;
            });
        }
        if (this.selectedMoneyType) {
            this.payment.get('currencyCode').setValue(this.selectedMoneyType.iso);
            this.payment.markAsDirty();
            this.payment.markAsTouched();
            this.clearSearchForm();
        }
        this.activeSearchMoneyTypes = false;
    }

    setActiveSearchMoneyTypes() {
        this.activeSearchMoneyTypes = !this.activeSearchMoneyTypes;
        if (this.activeSearchMoneyTypes) {
            // waiting for dom to update.
            setTimeout(() => {
                this.autoComplete['_element'].nativeElement.focus();
            }, 10);
        }
    }

    filterMoneyTypes(value) {
        const filterValue = value.toLowerCase();
        if (this.chat2payAPIData) {
            const { supportedCurrencies } = this.chat2payAPIData;
            this.filteredOptions = filter(supportedCurrencies, option => {
                return option.name.toLowerCase().includes(filterValue);
            });
        }
    }

    blurSearchMoneyType() {
        setTimeout(() => {
            this.activeSearchMoneyTypes = false;
        }, 200);
    }

    clearSearchForm() {
        this.searchControl.setValue('');
    }

    onExtensionChange(event) {
        const chat2payData = this.chat2payAllAPIData[event.value];
        if (chat2payData) {
            this.chat2payAPIData = chat2payData;
            this.setChat2payData(chat2payData);
        }
    }

    removeAdditionalDataItem(i) {
        this.additionalData.removeAt(i);
    }

    toggleGenerateOrderNumber(event) {
        this.updateOrderNumberRequiredValidator(!event.checked);
    }
    updateOrderNumberRequiredValidator(isRequired) {
        const orderNumber = this.menuParams.controls['orderNumber'];
        orderNumber.clearValidators();
        if (isRequired) {
            orderNumber.addValidators([required('Order Number'), variableOrValueLength()]);
        }
        orderNumber.updateValueAndValidity();
    }
}
